module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Auto-Driver.7291ade3.gif";